<template>
  <div>
    <b-modal
      id="modal-role"
      ref="my-modal"
      cancel-variant="outline-secondary"
      ok-title="Save"
      :ok-disabled="user_type === 'super-admin'"
      cancel-title="Close"
      centered
      :title="$t('DEBTIA_API_TOKEN_DETAILS')"
      size="lg"
      @hide="closeModal"
      @show="setValues"
      @close="closeModal"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="apiLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-form>
          <validation-observer
            ref="apiTokenForm"
            tag="form"
          >
            <b-row>
              <b-col
                v-if="details.id !== 0"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_CLIENT_ID')"
                  label-for="apiToken"
                  class="mb-2"
                >
                  <b-form-input
                    id="apiToken "
                    v-model="details.client_id"
                    type="text"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="details.id !== 0"
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_API_TOKEN_SECRET')"
                  label-for="apiToken"
                  class="mb-2"
                >
                  <b-form-input
                    id="apiToken "
                    v-model="details.secret"
                    type="text"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_TITLE')"
                  label-for="title"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="details.name"
                      type="text"
                      :placeholder="$t('DEBTIA_TITLE')"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="details.description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="8"
                      :readonly="user_type === 'super-admin'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                class="mb-2"
              >
                <b-form-checkbox
                  v-model="ipRestrictionStatus"
                  name="check-button"
                  switch
                  inline
                >
                  {{ $t('DEBTIA_IP_WHITELIST') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
        <b-alert
          v-if="ipRestrictionStatus && ipNull"
          show
          :variant="details.id !== 0 ? 'danger' : 'warning'"
          class="mb-1 p-1"
        >
          {{ $t('DEBTIA_IP_API_TOKEN_REQUIREMENT') }}
        </b-alert>
        <b-overlay
          v-if="ipRestrictionStatus"
          id="overlay-background"
          :show="ipLoader"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="sm"
          spinner-variant="primary"
          spinner-medium
        >
          <small
            v-if="ipError"
            class="text-danger"
          >{{ ipError }}</small>
          <b-form>
            <validation-observer
              ref="IPForm"
              tag="form"
            >
              <b-row>
                <b-col
                  lg="12"
                  class="mb-1"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="IP"
                    rules="required|IpPattern"
                  >
                    <!-- button on right -->
                    <b-input-group>
                      <b-form-input
                        v-model="ipString"
                        :placeholder="$t('DEBTIA_IP_TO_WHITELIST')"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="outline-primary"
                          @click="saveIp"
                        >
                          {{ $t('DEBTIA_ADD_IP') }}
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
              </b-row>
            </validation-observer>
          </b-form>
          <b-row
            v-if="unsavedIps.length > 0"
            class="mx-0 p-1"
          >
            <b-col
              md="12"
              class="revenue-report-wrapper"
            >
              <div class="d-sm-flex justify-content-between align-items-center mb-1">
                <h6 class="card-title mb-50 mb-sm-0">
                  {{ $t('DEBTIA_UNSAVED_IPS') }}
                </h6>
              </div>

              <b-table
                ref="roles"
                class="position-relative"
                :fields="tableFields"
                :items="unsavedIps"
              >
                <template #cell(action)="data">
                  <feather-icon
                    v-b-modal.modal-role
                    icon="Trash2Icon"
                    style="margin-left: 15px; color: #ff3737;"
                    @click="confirmDeletion(data.index, 0)"
                  />
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row class="mx-0 p-1">
            <b-col
              md="12"
              class="revenue-report-wrapper"
            >
              <div class="d-sm-flex justify-content-between align-items-center mb-1">
                <h6 class="card-title mb-50 mb-sm-0">
                  {{ $t('DEBTIA_SAVED_IPS') }}
                </h6>
              </div>

              <b-table
                ref="roles"
                class="position-relative"
                :fields="tableFields"
                :items="ips"
                show-empty
                :empty-text="$t('DEBTIA_NO_RECORD_FOUND')"
              >
                <template #cell(action)="data">
                  <feather-icon
                    v-b-modal.modal-role
                    icon="Trash2Icon"
                    style="margin-left: 15px; color: #ff3737;"
                    @click="confirmDeletion(data.item, 1)"
                  />
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-overlay>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BInputGroup, BFormGroup, BFormInput, BForm, BOverlay, BFormTextarea, BFormCheckbox, BButton, BTable, BAlert,
  BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import i18n from '@/libs/i18n'
import 'animate.css'
import axios from '@axios'
import constants from '@/app-configs/constants'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BFormTextarea,
    BFormCheckbox,
    BInputGroupAppend,
    BButton,
    BInputGroup,
    BTable,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    apiTokensData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      ipNull: false,
      ipRestrictionStatus: false,
      apiLoader: false,
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      ipString: null,
      ips: [],
      unsavedIps: [],
      ipLoader: false,
      user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      settingsChanged: false,
      ipError: null,
    }
  },
  computed: {
    tableFields() {
      const fields = [
        { key: 'ip', sortable: true, label: i18n.t('DEBTIA_IP') },
        {
          key: 'action', label: i18n.t('DEBTIA_ACTION'), thClass: 'text-right', tdClass: 'text-right',
        },
      ]
      return fields
    },
  },
  watch: {
    apiTokensData: {
      handler() {
        this.details = { ...this.apiTokensData }
        this.details.ip_whitelisting_status = this.details.ip_whitelisting_status === 1
      },
    },
    ipRestrictionStatus: {
      handler() {
        // if (this.ipRestrictionStatus && this.ipRestrictionStatus !== this.details.ip_whitelisting_status) this.settingsChanged = true
        if (this.details.id !== 0 && this.ipRestrictionStatus) this.fetchIps()
        if (!this.ipRestrictionStatus) this.refreshIPSettings()
      },
    },
    ipString: {
      handler() {
        this.ipError = null
      },
    },
  },
  methods: {
    closeModal(bvModalEvt) {
      if (bvModalEvt.trigger === 'ok') {
        return
      }
      if (this.details.id > 0 && (this.ips.length < 1 && this.details.ip_whitelisting_status)) {
        this.bounceIn()
        bvModalEvt.preventDefault()
      }
    },
    bounceIn() {
      this.$swal({
        text: i18n.t('DEBTIA_NO_IP_ON_CLOSE_MESSAGE'),
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn',
        },
        buttonsStyling: false,
      })
    },
    setValues() {
      this.ipRestrictionStatus = this.details.ip_whitelisting_status
      this.settingsChanged = false
      this.fetchIps()
    },
    confirmDeletion(id, type) {
      this.$swal({
        title: i18n.t('DEBTIA_DELETION_WARNING'),
        text: i18n.t('DEBTIA_DELETION_CONFIRMATION'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          if (type === 0) {
            this.deleteTemporaryIp(id)
          } else {
            this.deleteIp(id)
          }
        }
      })
    },
    deleteTemporaryIp(index) {
      if (index !== -1) {
        this.unsavedIps.splice(index, 1)
      }
    },
    refreshIPSettings() {
      this.ipNull = false
      this.ipString = null
      this.ips = []
      this.unsavedIps = []
    },
    async deleteIp(val) {
      this.ipLoader = true

      try {
        const response = await axios.delete(`/api-token/delete-ip/${val.id}`)

        if (response.status === 200) {
          const index = this.ips.findIndex(
            item => item.id === val.id,
          )

          if (index !== -1) {
            this.ips.splice(index, 1)
          }
          this.showToastMessage('Success', 'primary', response.data.message)
        }
      } catch (error) {
        const errMsg = error.response?.data?.message || 'Failed to delete IP.'
        this.showToastMessage('Error', 'danger', errMsg)
      } finally {
        this.ipLoader = false
      }
    },
    async fetchIps() {
      this.ips = []
      this.ipLoader = true
      const response = await axios.get(`/api-token/get-ips/${this.details.id}`)
      if (response.status) {
        this.ips = response.data.data.ips
        this.ipLoader = false
      }
    },
    async saveIp() {
      const success = await this.$refs.IPForm.validate()

      if (!success) {
        return
      }
      const exists = this.ips.some(item => item.ip === this.ipString) || this.unsavedIps.some(item => item.ip === this.ipString)
      if (exists) {
        this.ipError = `IP ${this.ipString} already exists in the list!`
        return
      }
      this.unsavedIps.push({
        ip: this.ipString,
      })
      this.$nextTick(() => {
        this.ipNull = false
      })
    },
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.apiTokenForm.validate().then(success => {
        if (this.ipRestrictionStatus && (this.unsavedIps.length === 0 && this.ips.length === 0)) {
          this.ipNull = true
          return
        }
        if (success) {
          this.details.ip_whitelisting_status = this.ipRestrictionStatus ? 1 : 0
          this.details.unSavedIps = this.unsavedIps
          this.apiLoader = true
          let url = ''
          if (this.details.id > 0) {
            url = `${constants.baseUrl}/api-token/update/${this.details.id}`
          } else {
            url = `${constants.baseUrl}/api-token/create`
          }
          axios.post(url, { ...this.details }).then(response => {
            if (response.status === 200) {
              this.$nextTick(() => {
                this.apiLoader = false
                this.$refs['my-modal'].toggle('#toggle-btn')
              })
              this.details = {
                id: 0, apiToken: '', name: '', description: '', parent_id: JSON.parse(localStorage.getItem('userData')).data.id,
              }
              this.reloadMethod()
              this.refreshIPSettings()
              this.settingsChanged = false
            }
          })
        }
      })
    },
    showToastMessage(title, variant, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon: 'CoffeeIcon',
          variant,
          text,
        },
      })
    },
  },
}
</script>

<style lang="scss">

</style>
